import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ControlPointDuplicateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"control_point_duplicate"}/>
}
